import { render, staticRenderFns } from "./LastTenSession.vue?vue&type=template&id=6c5da6ee&scoped=true&"
import script from "./LastTenSession.vue?vue&type=script&lang=ts&"
export * from "./LastTenSession.vue?vue&type=script&lang=ts&"
import style0 from "./LastTenSession.vue?vue&type=style&index=0&id=6c5da6ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5da6ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VChip,VProgressCircular})
